import azState from '../../../../assets/arizona_map.png';
import donut from '../../../../assets/ring_chart.png';
import pie from '../../../../assets/gauge_pie_chart.png';

export const charts = [
    { 
        id: "title_map",
        icon: azState, 
        name: "Agriculture: Title Map", 
        desc: "Explanation about what this means and what the narrative measures on the base level.", 
        title: "Agriculture: Title Map",
        subtitle: "",
        floating_title: true,
        scenario_disabled: false,
        metrics: [
            { label: "Agriculture: Use of Colorado River Water", value: "Xxx,xxx ac-ft" },
            { label: "Metric Name", value: "Xxx,xxx ac-ft" },
            { label: "Metric Name", value: "Xxx,xxx ac-ft" },
            { label: "Metric Name", value: "Xxx,xxx ac-ft" },
            { label: "Metric Name", value: "Xxx,xxx ac-ft" },
            { label: "Metric Name", value: "Xxx,xxx ac-ft" },
            { label: "Metric Name", value: "Xxx,xxx ac-ft" },
        ]
    },
    { 
        id: "district_water_user",
        icon: donut, 
        name: "Agriculture District Water Use", 
        desc: "Explanation about what this means and what the narrative measures on the base level.", 
        title: "Agriculture District Water Use",
        subtitle: "",
        floating_title: false,
        scenario_disabled: true,
        metrics: [
            { label: "Agriculture: Use of Colorado River Water", value: "Xxx,xxx ac-ft" },
            { label: "Metric Name", value: "Xxx,xxx ac-ft" },
            { label: "Metric Name", value: "Xxx,xxx ac-ft" },
            { label: "Metric Name", value: "Xxx,xxx ac-ft" },
            { label: "Metric Name", value: "Xxx,xxx ac-ft" },
            { label: "Metric Name", value: "Xxx,xxx ac-ft" },
            { label: "Metric Name", value: "Xxx,xxx ac-ft" },
        ]
    },
    { 
        id: "irrigation_district_water_deliveries",
        icon: pie, 
        name: "Agriculture: Irrigation District Water Deliveries", 
        desc: "Explanation about what this means and what the narrative measures on the base level.", 
        title: "Agriculture: Irrigation District Water Deliveries",
        subtitle: "",
        floating_title: false,
        scenario_disabled: true,
        metrics: [
            { label: "Metric Name", value: "Xx,xxx ac-ft" },
            { label: "Metric Name", value: "Xx,xxx ac-ft" },
            { label: "Metric Name", value: "Xx,xxx ac-ft" },
            { label: "Metric Name", value: "Xx,xxx ac-ft" },
            { label: "Metric Name", value: "Xx,xxx ac-ft" },
            { label: "Metric Name", value: "Xx,xxx ac-ft" },
            { label: "Metric Name", value: "Xx,xxx ac-ft" },
        ]
    },
];

export const about = [
    {title:"Summary", desc: "This map shows Central Arizona irrigation districts with access to Colorado River water delivered through the Central Arizona Project (CAP) canal. Irrigation districts in Central Arizona do not have entitlements to Colorado River water, but maintain access through partnerships with cities, tribes, and others. A partner delivers Colorado River water to the district, which then uses the water instead of pumping groundwater. The groundwater thus \"saved\" becomes available to the partner to pump or sell in the future. The stat shows an irrigation district’s use of Colorado River water in 2020."},
    {title:"Summary", desc: "Irrigation districts have access to various water supplies.  With this chart, a user can see the water sources used by each district in 2020."},
    {title:"Summary", desc: "Irrigation districs often deliver water for more purposes than just growing crops - particularly in urban areas. With this chart, a user can see the purposes for which an irrigation district used its combined water supplies in 2020."},
  ];

export const agriculture = [
    { label: 'Subject', value: 0 }, 
    { label: 'Subject', value: 1 }, 
    { label: 'Subject', value: 2 }, 
    { label: 'Subject', value: 3 }, 
];